'use strict';

export default class Footerv3 {
  constructor(element) {
    this.element = element;
    this.form = this.element.querySelector('.js-newsletter-form');
    
    if (this.form) {
      this.inputs = this.form.querySelectorAll('.js-newsletter-input');
      this.button = this.form.querySelector('.js-newsletter-button');
      this.init();
    }
  }

  init() {
    this.inputs.forEach(input => {
      input.addEventListener('input', () => this.validateForm());
    });
  }

  validateForm() {
    let allFilled = true;
    
    this.inputs.forEach(input => {
      if (!input.value.trim()) {
        allFilled = false;
      }
    });

    this.button.disabled = !allFilled;
  }
}
